import { Action, ApiStatus, MessageType } from 'common/enums';
import {
    DEFAULT_COUNT,
    PAGE_SIZE_DEFAULT,
    PAGE_NUMBER_DEFAULT
} from 'common/config/pagination.config';
import { SessionState } from 'modules/session-management/models/session.model';

const initialSessionState: SessionState = {
    isSessionModalVisible: false,
    editData: undefined,
    sessionList: {
        data: [],
        pageSize: PAGE_SIZE_DEFAULT,
        currentPage: PAGE_NUMBER_DEFAULT,
        totalCount: DEFAULT_COUNT,
        totalPages: DEFAULT_COUNT,
        status: ApiStatus.NONE,
        error: {}
    },
    organiserList: {
        data: [],
        pageSize: PAGE_SIZE_DEFAULT,
        currentPage: PAGE_NUMBER_DEFAULT,
        totalCount: DEFAULT_COUNT,
        totalPages: DEFAULT_COUNT,
        status: ApiStatus.NONE,
        error: {}
    },
    sessionCreateStatus: {},
    sessionDeleteStatus: {},
    sessionArchiveStatus: {},
    sessionEditStatus: {},
    notificationPopupState: { isVisible: false, mode: Action.Default },
    sessionCode: {
        organiser: '',
        participant: ''
    },
    messageStatus: {
        type: MessageType.Default,
        message: ''
    },
    fieldErrors: []
};

export default initialSessionState;
